<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
</script>

<template>
    <footer class="footer">
        <div class="inner">
            <div class="logo">
                <img src="/src/assets/images/logo_w.png" alt="logo" />
            </div>
            <div>
              서울특별시 송파구 중대로 211, 한국디스플레이산업회관 <i></i> 02-3014-5713
            </div>
            <div>
              사업자번호 : 220-82-07490 한국디스플레이산업협회 (대표자 : 이청), 220-82-00124 한국디스플레이산업협회 (대표자 : 이청)
            </div>
            <div>
              <ul class="policy">
                <li @click="router.push({name:'terms'})">이용약관</li>
                <li @click="router.push({name:'personal'})">개인정보처리방침</li>
                <li @click="router.push({name:'emailRejection'})">이메일무단수집거부</li>
              </ul>
              <i></i>
              © Copyright 2025, KDA, all rights reserved
            </div>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
    @import "../assets/scss/theme";

    .footer {
        width: 100%;
        background: #2E2E2E;
        color: #919191;
        @include font-size_sm;
        padding: 28px 10px;
        text-align: left;
        .inner > div {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
        }
        div.logo {
          width: 100%;
          display: block;
          margin-bottom: 16px;
        }
        i {
          display: inline-block;
          width: 1px;
          height: 8px;
          background: #919191;
          margin-inline: 4px;
          margin-top: 2px;
        }
        .policy {
          display: flex;
          align-items: center;
          gap: 4px;
          color: #fff;
          cursor: pointer;
          li {
            position: relative;
            color: #fff;
            padding-left: 4px;
            &:before {
              content: '';
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
              height: 8px;
              width: 1px;
              background: #919191;
            }
            &:first-child {
              padding-left: 0;
              &:before {
                display: none;
              }
            }
          }
        }

      @media (max-width: 524px) {
        div {
          display: block !important;
          width: 100%;
          i {
            display: none;
          }
        }
      }
    }
</style>